import React, { useRef, useState, useEffect } from 'react';
import WrapperWithRecovery from './WrapperWithRecovery.js';
import { formatText } from '../../utils/formatters';

const WidgetAvatar = ({ textResult, prompt, onAvatarPlay, isPlaying, isProcessing, setIsPlaying }) => {
  const [isAvatarHovered, setIsAvatarHovered] = useState(false);
  const avatarIframeRef = useRef(null);
  const audioRef = useRef(new Audio());

  useEffect(() => {
    const triggerAvatarStart = () => {
      if (avatarIframeRef.current) {
        try {
          const iframeDocument = avatarIframeRef.current.contentDocument ||
            (avatarIframeRef.current.contentWindow && avatarIframeRef.current.contentWindow.document);

          if (iframeDocument) {
            const possibleSelectors = [
              '.start-button', 'button', '[role="button"]',
              '.play-button', '#start', 'a.start', '.avatar-start',
            ];

            for (const selector of possibleSelectors) {
              const elements = iframeDocument.querySelectorAll(selector);
              for (const element of elements) {
                element.click();
              }
            }
          }
        } catch (e) {
          console.error("Could not auto-start avatar due to same-origin policy:", e);
        }
      }
    };

    const attempts = [500, 1000, 1500, 2000, 3000];
    const timeoutIds = attempts.map(delay => setTimeout(triggerAvatarStart, delay));

    if (avatarIframeRef.current) {
      avatarIframeRef.current.onload = triggerAvatarStart;
    }

    return () => timeoutIds.forEach(id => clearTimeout(id));
  }, []);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
      }
    };
  }, []);

  return (
    <div className="w-full">
      <div className="gap-5">
        <div
          className="relative flex items-center justify-center overflow-hidden rounded-lg mb-4"
          onMouseEnter={() => setIsAvatarHovered(true)}
          onMouseLeave={() => setIsAvatarHovered(false)}
        >
          <WrapperWithRecovery
            settings={{
              AutoPlayVideo: true,
              AutoConnect: true,
              StartVideoMuted: false,
              // ss: "wss://18.208.58.92:8443",
              ss: window.location.protocol === 'https:' ?
                "wss://18.208.58.92:8443" :
                "ws://18.208.58.92:30080",
              peerConnectionOptions: {
                iceServers: [
                  {
                    urls: ["turn:18.208.58.92:3478"],
                    username: "user",
                    credential: "password"
                  }
                ],
                iceTransportPolicy: "relay"
              },
              HoveringMouse: true,
              WaitForStreamer: true,
              HideUI: true,
              WebRTCMaxBitrate: 10000,
            }}
            ref={avatarIframeRef}
          />
          {!isPlaying && !isProcessing && (isAvatarHovered || isProcessing) && (
            <button
              onClick={onAvatarPlay}
              disabled={isProcessing}
              className="absolute left-1/2 top-1/2 transform bg-white border-none rounded-full w-6 h-6 shadow-md flex items-center justify-center cursor-pointer z-10 opacity-100 disabled:opacity-60 disabled:cursor-not-allowed"
              title="Play"
            >
              <svg width="12" height="12" viewBox="0 0 32 32">
                <circle cx="16" cy="16" r="16" fill="#fff" />
                <polygon points="12,9 26,16 12,23" fill="#1976d2" />
              </svg>
            </button>
          )}
          <audio ref={audioRef} onEnded={() => setIsPlaying(false)} />
        </div>
        <div
          className="pr-2 pl-1 flex-1 text-gray-700 text-sm leading-relaxed font-sans whitespace-normal break-words scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent"
          dangerouslySetInnerHTML={{ __html: formatText(textResult, prompt) }}
        />
      </div>
    </div>
  );
};

export default WidgetAvatar;